<template>
  <div style="padding: 20px;background-color: #ffffff;">
    <div class="">
      <div @keyup.enter.stop="getPage({pageNum: 1})">
        <el-input style="width:200px;margin-right:10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.username" clearable placeholder="姓名"></el-input>
        <el-input style="width:200px;margin-right:10px;" @clear="getPage({pageNum: 1})" v-model="queryParam.mobile" clearable placeholder="手机号"></el-input>
        <el-button @click="getPage({pageNum: 1})" type="primary">搜索</el-button>
      </div>
    </div>
    <div ref="chart" style="width: 100%;height: 300px;"></div>
    <div ref="chart2" style="width: 100%;height: 400px;"></div>
    <div ref="chart3" style="width: 100%;height: 400px;"></div>
  </div>
</template>
<script>
import echarts from 'echarts'

export default {
  name: 'enroll',
  components: {},
  props: [],
  data () {
    return {
      tableHeight: 200,
      queryParam: { username: '', mobile: '' },
      page: { pageSize: 20, pageNum: 1 },
      editForm: { show: false, dataId: '', title: '账号' }
    }
  },
  async created () {
    await this.getPage()
  },
  async mounted () {
  },
  async beforeDestroy () {
  },
  computed: {},
  watch: {},
  methods: {
    async getPage (queryParam) {
      try {
        this.queryParam = Object.assign({}, this.queryParam, queryParam)
        let page = await this.$HTTP.ApiUser.getPage(this.queryParam)
        this.page = page
        this.initChart()
        this.initChart2()
        this.initChart3()
      } catch (e) {
        this.Tool.doError(e)
      }
    },
    initChart () {
      echarts.init(this.$refs['chart']).setOption({
        legend: {},
        tooltip: {},
        dataset: {
          dimensions: ['product', '2015', '2016', '2017'],
          source: [
            { product: 'Matcha Latte', '2015': 43.3, '2016': 85.8, '2017': 93.7 },
            { product: 'Milk Tea', '2015': 83.1, '2016': 73.4, '2017': 55.1 },
            { product: 'Cheese Cocoa', '2015': 86.4, '2016': 65.2, '2017': 82.5 },
            { product: 'Walnut Brownie', '2015': 72.4, '2016': 53.9, '2017': 39.1 }
          ]
        },
        xAxis: { type: 'category' },
        yAxis: {},
        series: [
          { type: 'line' },
          { type: 'line' },
          { type: 'line' }
        ]
      })
    },
    initChart2 () {
      echarts.init(this.$refs['chart2']).setOption({
        legend: {
          orient: 'vertical',
          right: 10
        },
        tooltip: {},
        dataset: {
          dimensions: ['product', '2015', '2016', '2017'],
          source: [
            { product: 'Matcha Latte', '2015': 43.3, '2016': 85.8, '2017': 93.7 },
            { product: 'Milk Tea', '2015': 83.1, '2016': 73.4, '2017': 55.1 },
            { product: 'Cheese Cocoa', '2015': 86.4, '2016': 65.2, '2017': 82.5 },
            { product: 'Walnut Brownie', '2015': 72.4, '2016': 53.9, '2017': 39.1 }
          ]
        },
        series: [
          { type: 'pie', radius: ['50%', '70%'] },
          { type: 'pie', radius: ['50%', '70%'] },
          { type: 'pie', radius: ['50%', '70%'] }
        ]
      })
    },
    initChart3 () {
      echarts.init(this.$refs['chart3']).setOption({
        color: ['#ff00ff', '#2f4554', '#61a0a8', '#d48265', '#91c7ae', '#749f83', '#ca8622', '#bda29a', '#6e7074', '#546570', '#c4ccd3'],
        legend: {},
        tooltip: {},
        dataset: {
          dimensions: ['product', '2015', '2016', '2017'],
          source: [
            { product: 'Matcha Latte', '2015': 43.3, '2016': 85.8, '2017': 93.7 },
            { product: 'Milk Tea', '2015': 83.1, '2016': 73.4, '2017': 55.1 },
            { product: 'Cheese Cocoa', '2015': 86.4, '2016': 65.2, '2017': 82.5 },
            { product: 'Walnut Brownie', '2015': 72.4, '2016': 53.9, '2017': 39.1 }
          ]
        },
        xAxis: { type: 'category', boundaryGap: false },
        yAxis: { type: 'value' },
        series: [
          { type: 'line', areaStyle: {} },
          { type: 'line', areaStyle: {} },
          { type: 'line', areaStyle: {} }
        ]
      })
    }
  }
}
</script>
